import ApiOff from './apioff'

/**
 * @type {Register}
 */
export default class Register extends ApiOff {

    register(data) {
        return this.http.post('/newbroker', data)
    }
}
